export default {
	title: "",
	subtitle: "Payout",
	path: "transaction_SPEI_PAYOUT",
	paragraphs: [
		"After registering your customer bank account with us, you will be able to pay them locally using the following endpoint. We will use the CLABE details you registered with us.",
		"The payout transactions can be initiated within your foreign currency cash-out account or your Mexican cash-out account.",
		"*If you prefer to do a payout with the full value already in local currency, please refer to section 'Reverse Exchange' of this documentation. "
	],
	request: {
		method: "POST",
		endpoint: "/transactions",
		payload: {
			"transaction": {
				"currency": "USD or MXN",
				"exchange_currency": "MXN",
				"value": "500.00",
				"from_bank_account_id": "your USD/MXN cash-out internal account id",
				"to_bank_account_id":  "the id of your customer bank account",
				"subject_id": "your customer id"
			}
		},
		responses:{
			"data": {
				"value": "500.00",
				"to_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "Horacio",
					"owner_document_type": "curp",
					"owner_document_number": "SOMH031031HSRTRR04",
					"nickname": null,
					"intermediary_bank_account_id": null,
					"id": "ec0101ea-4de2-413f-8f30-4dfef8608e0e",
					"iban": null,
					"currency": "MXN",
					"branch_number": null,
					"branch_country": null,
					"bank": {
						"swift": null,
						"name": "IXE Banco, S.A",
						"ispb": null,
						"id": "9563453e-05fb-41e2-a915-15d7abe3fb08",
						"country": "MEX",
						"code": "032"
					},
					"account_type": "conta-corrente",
					"account_number": "231056315610651",
					"aba": null
				},
				"subject_is_receiver": true,
				"subject_id": "ac3bf8d8-e299-4fe9-8565-2ff6fe7c2dec",
				"status": "identified",
				"source_name": "Horacio Soto Morales",
				"source_document_type": "curp",
				"source_document_number": "SOMH031031HSRTRR04",
				"meta": null,
				"inserted_at": "2025-07-10T17:27:53.250740",
				"id": "5417d353-62d1-4d70-976d-b385817f6c51",
				"from_credit_card_id": null,
				"from_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "Biriweb Serviços de Internet Ltd",
					"owner_document_type": null,
					"owner_document_number": "21958642819",
					"nickname": null,
					"internal": true,
					"intermediary_bank_account_id": null,
					"id": "97c29459-e087-4358-bbaf-5597a76b3b80",
					"iban": null,
					"currency": "MXN",
					"branch_number": null,
					"branch_country": "MEX",
					"bank": {
						"swift": null,
						"name": "Internal",
						"ispb": null,
						"id": "6facab8d-573e-44d0-a4bd-ce2600368263",
						"country": "BRA",
						"code": "999"
					},
					"account_type": "conta-corrente",
					"account_number": null,
					"aba": null
				},
				"for_exchange": false,
				"exchanged_value": "500.00",
				"exchange_under_request": false,
				"exchange_currency": "MXN",
				"estimated_value_until_exchange": false,
				"currency": "MXN",
				"cleared": true,
				"bank_transaction": {
					"wire_id": null,
					"value": "500.0",
					"spei_reference": null,
					"spei_concepto_de_pago": null,
					"source_type": "SPEI-PRE",
					"source_name": "Horacio Soto Morales",
					"source_id": "5417d353-62d1-4d70-976d-b385817f6c51",
					"source_document_type": "curp",
					"source_document_number": "SOMH031031HSRTRR04",
					"source_description": "CREDITO POR SPEI ANTECIPADO",
					"source_branch": null,
					"source_bank_ispb": null,
					"source_bank": null,
					"source_account": null,
					"movement_date": "2025-07-10",
					"iof_value": "0.00",
					"inserted_at": "2025-07-10T17:27:53.269976",
					"id": "38c8053b-cf35-4cac-aee3-8e260af87d28",
					"exchanged_value": "500.00",
					"exchange_rate_spot": null,
					"exchange_rate": "1.0",
					"exchange_id": "1562226e-b9e9-4928-ae79-f50fed77af88",
					"exchange_currency": "MXN",
					"exchange_approved": true,
					"currency": "MXN"
				}
			}
		}
	},
	parameterPayload: [
		{
			name: "transaction",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
        },
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "Currency of your internal bank account.",
		}, {
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "For SPEI, always use \"MXN\" currency"
		}, {
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Amount to be sent to FacilitaPay or deducted from an internal bank account balance"
		}, {
			name: "transaction.from_bank_account_id",
			type: "string",
			required: true,
			description: "UUID of your internal bank account. Its currency must match the currency informed on the currency attribute"
		}, {
			name: "transaction.to_bank_account_id",
			type: "string",
			required: true,
			description: "Destination bank account UUID. This bank account must be from your Mexican customer"
		}, {
			name: "transaction.subject_id",
			type: "string",
			required: true,
			description: "UUID of your customer, i.e. the owner of the to_bank_account_id"
		},
	],
	footerNotes: '',
	troubleshooting: {}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionSpeiPayout.js